import { FC } from "react";
import PercentageButton from "../../pages/Swap/components/PercentageButton"; // Import the new component
import cn from "classnames";
interface Props {
    balance: number | string;
    setAmount: (value: string) => void;
    active: boolean; // Determines if the set of buttons is active
    mobile?: boolean;
}

const AmountButtons: FC<Props> = ({ balance, setAmount, active, mobile }) => {
    const percentages = [1, 0.75, 0.5, 0.25];

    // Function to calculate the amount for a given percentage
    const calculateAmount = (percentage: number) => {
        return (Math.floor(Number(balance) * percentage * 10000) / 10000).toString();
    };

    return (
        <div
            className={cn(
                "flex transition-opacity duration-200 rounded-full ease-in-out text-[0.8rem]",
                mobile ? "gap-2 " : "assented px-1 divide-accent/50 divide-x-1  py-2",
                active ? "opacity-100 " : "opacity-30 ",
            )}
        >
            {percentages.map((percentage) => (
                <PercentageButton
                    key={percentage}
                    percentage={percentage}
                    onClick={() => setAmount(calculateAmount(percentage))}
                    isActive={active} // Pass the active state to the individual button
                    mobile={false}
                />
            ))}
        </div>
    );
};

export default AmountButtons;
